import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import styled from "styled-components";
import { Col, Container, Row, Button } from "reactstrap";
import TopToolbar from "components/Whiteboard/TopToolbar/TopToolbar.jsx";
import FabricCanvas from "components/Whiteboard/FabricCanvas.js";
import ProductGroup from "components/Whiteboard/ProductGroup/ProductGroup.jsx";
import RightPanel from "components/Whiteboard/RightPanel/RightPanel.jsx";
import IconPlus from "assets/icons/plus.svg";
import IconMinus from "assets/icons/minus.svg";
import $ from "jquery";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { ResizableBox } from 'react-resizable';
import Alert from "components/AlertDismissible";

import { getBannerInfo } from "actions/bannerInfoActions.js";
import {
  getBuyplanSummary,
} from "actions/buyplanSummaryActions.js";

import { currentUserDataSelector } from "selectors/currentUserSelector.js";

import { preOrderCustomTextSelector } from "selectors/buyplanInfoSelector";
import {
  buyplanSummaryBuyplanItemsSelector
} from "selectors/buyplanSummarySelector.js";

import {
  setCanvasBuyplanItems,
  setMainBuyplanItems,
  setSelectorBuyplanItems,
  setSelMonth,
  updateSelectionCanvasItems
} from "components/Whiteboard/Helpers";

import { appliedFiltersSelector } from "selectors/filtersSelector";
import { getBuyplanId } from "actions/buyplanIdActions.js";
import { buyplanIdSelector } from "selectors/buyplanIdSelector.js";

const WhiteboardAppLayout = () => {

  const [rezHeight, setRezHeight] = useState(0);
  const [rezInitHeight, setRezInitHeight] = useState(0);
  const [showDismissibleAlertBanner, setShowDismissibleAlertBanner] = useState(false);
  const currentUser = useSelector(currentUserDataSelector);
  var confirmedBuyplanId = useSelector(buyplanIdSelector);

  const appliedFilters = useSelector(appliedFiltersSelector);
  const buyplanItems = useSelector(buyplanSummaryBuyplanItemsSelector);
  const preOrderCustomText = useSelector(preOrderCustomTextSelector);
  const sortedBuyplanItems = buyplanItems
    .filterNot((val, key) => key === preOrderCustomText)
    .sortBy(buyplanItem => buyplanItem);

  const [clicks, setClicks] = useState(1);
  const dispatch = useDispatch();
  const { releaseId, month } = useParams();
  var { buyplanId } = useParams();
  const history = useHistory();

  
  if (buyplanId) {
    confirmedBuyplanId = buyplanId;
  } else if (!buyplanId) {
    dispatch(getBuyplanId({ releaseId }));
  }

  useEffect(() => {
    buyplanId = confirmedBuyplanId;
    buyplanId &&
      dispatch(getBuyplanSummary(buyplanId, appliedFilters.toJS()));
  }, [
    dispatch,
    confirmedBuyplanId
  ]);

  //get buy plan item data
  useEffect(() => {
    setShowDismissibleAlertBanner(true);
    buyplanId &&
      dispatch(getBuyplanSummary(buyplanId, appliedFilters.toJS()));
  }, [dispatch, buyplanId, appliedFilters]);

  // get banner info
  useEffect(() => {
    dispatch(getBannerInfo(releaseId));
  }, [dispatch, releaseId]);

  useEffect(() => {

    setSelMonth(month);
    setMainBuyplanItems(buyplanItems);

    if ($("#applyto_selector").prop('checked') && buyplanItems && buyplanItems.size) {
      setSelectorBuyplanItems(buyplanItems);
    }

    if (buyplanItems && buyplanItems.size && $("#applyto_canvas").prop('checked')) {
      setCanvasBuyplanItems(buyplanItems);
      updateSelectionCanvasItems();
    }

    if ($('.productGroupsSlider').css('height')) {
      var ph = $('.productGroupsSlider').css('height').replace('px', '');

      if (parseInt(ph)) {
        setRezInitHeight(parseInt(ph) * 1.5);
      }
    }

    productsListResize();

    window.onresize = function () {
      productsListResize();
    };
  });

  const incrementItemZoom = () => {
    if (clicks >= 12) setClicks(12);
    else setClicks(clicks + 1);
  };

  const decreaseItemZoom = () => {
    if (clicks <= 1) setClicks(1);
    else setClicks(clicks - 1);
  };

  const closeModalFn = () => {
    var path = history.location.pathname;
    path = path.replace(`/whiteboard/${month}`, '');
    history.push(
      path
    );
  };

  function productsListResize() {

    if (!$('.productsList').css('width'))
      return false;
    if (!$('.productGroupsSlider').css('height'))
      return false;

    var ph = $('.productGroupsSlider').css('height').replace('px', '');

    setRezHeight(parseInt(ph));
  };

  function onProductListResize(e) {

    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }

    var h = e.clientY;

    if (h < 50)
      h = 50;
    if (h > rezInitHeight)
      h = rezInitHeight;

    $('.productGroupsSlider').css('height', h + 'px');

    productsListResize();
  };

  const closeBtn = (
    <button className="close" onClick={closeModalFn} type="button">
      &times;
    </button>
  );

  return (
    <>

      <Modal
        isOpen={true}
        backdrop={"static"}
        id="WhiteboardModal"
      >
        <ModalHeader toggle={closeModalFn} close={closeBtn}>
          <TopToolbar sortedBuyplanItems={sortedBuyplanItems} currentUser={currentUser} buyplanId={confirmedBuyplanId} />
        </ModalHeader >
        <ModalBody>
          <Container className="avc" fluid>
            <Row>
            
              <Col md="10">
              { showDismissibleAlertBanner && <Alert></Alert> }
                <div className="canvasArea">
                  <FabricCanvas buyplanId={confirmedBuyplanId} />
                </div>
                <div className="productsList">

                  <ResizableBox height={rezHeight} onResize={onProductListResize} axis={'y'} draggableOpts={{ grid: [1, 1] }}
                    minConstraints={[50, 50]} maxConstraints={[rezInitHeight, rezInitHeight]}>

                    <div
                      className={
                        "productGroupsSlider productSize-" + clicks
                      }
                    >

                      <ProductGroup buyplanItems={buyplanItems} />

                    </div>

                  </ResizableBox>

                  <div className="zoomZoomout">
                    <Button
                      outline
                      className="btnZoomout"
                      onClick={decreaseItemZoom}
                    >
                      <img src={IconMinus} alt="" />
                    </Button>
                    <Button
                      outline
                      className="btnZoom"
                      onClick={incrementItemZoom}
                    >
                      <img src={IconPlus} alt="" />
                    </Button>
                  </div>
                </div>
              </Col>
              <Col md="2">
                <RightPanel buyplanId={confirmedBuyplanId}/>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

const StyledAppLayout = styled(WhiteboardAppLayout)`
`;

export default React.memo(StyledAppLayout);
